module.exports = __webpack_public_path__ + "img/gradient-13.447ae123.png";